var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

const React = require('react');
const Icon = require('@infotech/uikit-icon').default;

function Svg(props) {
  const svgProps = Object.assign({}, props);
  const title = props.title;
  delete props.title;

  /* <svg {...svgProps} ><title>{title}<title>...</svg> */
  return React.createElement(
    'svg',
    _extends({ width: '18', height: '12', viewBox: '0 0 18 12', focusable: 'false' }, svgProps, { 'aria-labelledby': 'title' }),
    React.createElement(
      'title',
      { id: 'title' },
      title
    ),
    React.createElement('path', { fill: '#313233', d: 'M5 2H1a1 1 0 110-2h4a1 1 0 110 2zm12 10H1a1 1 0 110-2h16a1 1 0 110 2zm-6-5H1a1 1 0 110-2h10a1 1 0 110 2z', opacity: '.402', fillRule: 'evenodd', role: 'presentation' })
  );
}

module.exports = function sortDown(props) {
  return React.createElement(Icon, _extends({ glyph: Svg }, props));
};